"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateValeLink = void 0;
var date_unix_1 = require("./date-unix");
function generateValeLink(item) {
    return "https://vale.gbc.pe/v2/card/validate/".concat(item.id, "?t=").concat((0, date_unix_1.dateUnix)(item.created_at));
}
exports.generateValeLink = generateValeLink;
